import { createQueryHook } from '../internal/createQueryHook';
import { getMemberQuery } from '../queries/members';

/**
 * @deprecated Use `getMemberQuery()` with `useQuery` directly.
 */
export const useMember = createQueryHook(({ memberId }: { memberId: string }) => getMemberQuery({ id: memberId }));
